"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShareDialogFrame = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var FRAME_CLASS = "relative rounded-lg font-[Inter] shadow-lg ring-1 ring-border-default [&>div]:max-w-[calc(100vw-var(--share-dialog-viewport-gutter))]!";
var ShareDialogFrame = exports.ShareDialogFrame = function ShareDialogFrame(_ref) {
  var viewportGutterPx = _ref.viewportGutterPx,
    children = _ref.children;
  var gutterStyle = {
    "--share-dialog-viewport-gutter": "".concat(viewportGutterPx, "px")
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    style: gutterStyle,
    className: FRAME_CLASS,
    "data-sentry-component": "ShareDialogFrame",
    "data-sentry-source-file": "share-dialog-frame.tsx",
    children: children
  });
};